import { ProjectActionTypes, All } from '../actions/project.actions';
import { Project, ProjectSearchCriteria, RequestStatus, ProjectSetupValues, User, PageLayout, MasterRegionTemplate, Studio } from '@app/shared';

// define State interface
export interface State {
  // is a user authenticated?
  selectedProject: Project | null;
  // if authenticated, there should be a user object
  projects: Project[] | null;
  errorStatus: RequestStatus | null;
  successStatus: RequestStatus | null;
  isEditing: boolean | null;
  actionType:String | null;
  searchCriteria:ProjectSearchCriteria | null;
  authorisers:User[] | null;
  documentSubTypes:any[] | null;
  pageLayouts:PageLayout[] | null;
  masterRegionTemplates:MasterRegionTemplate[] | null;
  pageBackgrounds:any[] | null;
  businessBrands:any[] | null;
  studios:Studio[] | null;
  studioPref:any[] | null;
  selectedStatus: string;
}

// define initial state
export const initialState: State = {

  selectedProject: null,
  projects: null,
  isEditing:false,
  errorStatus:null,
  successStatus:null,
  actionType:null,
  searchCriteria:null,
  authorisers:null,
  documentSubTypes:null,
  pageLayouts:null,
  masterRegionTemplates:null,
  pageBackgrounds:null,
  businessBrands:null,
  studios:null,
  studioPref:null,
  selectedStatus: 'active'
};

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case ProjectActionTypes.GET_PROJECTS_SUCCESS: {
      return {
        ...state,
        projects: action.payload.projects,
        errorStatus:null,
        actionType:action.type,
        searchCriteria:action.payload.updateSearchCriteria?action.payload.searchCriteria:state.searchCriteria,
        selectedStatus: action.payload.status || state.selectedStatus,
      };
    }
    case ProjectActionTypes.RETIRE_PROJECT_SUCCESS:
      return {
        ...state,
        selectedProject: action.payload.project,
        actionType:action.type,
        successStatus:action.payload.successStatus,
        errorStatus:null,
    };
    case ProjectActionTypes.RESTORE_PROJECT_SUCCESS:
      return {
        ...state,
        selectedProject: action.payload.project,
        actionType:action.type,
        successStatus:action.payload.successStatus,
        errorStatus:null,
    };
    case ProjectActionTypes.GET_PERSONS_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        actionType:action.type,
        authorisers:action.payload.authorisers,
      };
    }
    case ProjectActionTypes.GET_DOCUMENT_SUB_TYPES_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        actionType:action.type,
        documentSubTypes:action.payload.documentSubTypes,
      };
    }
    case ProjectActionTypes.GET_PAGE_LAYOUTS_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        actionType:action.type,
        pageLayouts:action.payload.pageLayouts,
      };
    }
    case ProjectActionTypes.GET_MASTER_REGION_TEMPLATES_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        actionType:action.type,
        masterRegionTemplates:action.payload.masterRegionTemplates,
      };
    }
    case ProjectActionTypes.GET_PAGE_BACKGROUNDS_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        actionType:action.type,
        pageBackgrounds:action.payload.pageBackgrounds,
      };
    }
    case ProjectActionTypes.GET_BUSINESS_BRANDS_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        actionType:action.type,
        businessBrands:action.payload.businessBrands,
      };
    }
    case ProjectActionTypes.GET_STUDIOS_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        actionType:action.type,
        studios:action.payload.studios,
      };
    }
    case ProjectActionTypes.GET_STUDIO_PREF_SUCCESS: {	
      return {	
        ...state,	
        errorStatus:null,	
        actionType:action.type,	
        studioPref:action.payload.studioPref,	
      };	
    }
    case ProjectActionTypes.VALIDATE_PROJECT_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        actionType:action.type,
        successStatus:action.payload.successStatus,
      };
    }
    case ProjectActionTypes.GET_PROJECT_SUCCESS:
    case ProjectActionTypes.SHOW_PROJECT_INFO:
    case ProjectActionTypes.SHOW_ARRANGE_PAGES:
    case ProjectActionTypes.SHOW_COPY_PROJECT:
    case ProjectActionTypes.SET_PROJECT: {
      return {
        ...state,
        selectedProject: action.payload.project,
        actionType:action.type,
        successStatus:null,
        errorStatus:null,
      };
    }
    case ProjectActionTypes.CREATE_PROJECT:
    case ProjectActionTypes.EDIT_PROJECT: {
      return {
        ...state,
        selectedProject: action.payload.project,
        isEditing: action.payload.isEditing,
        actionType:action.type,
        successStatus:null,
        errorStatus:null,
      };
    }
    case ProjectActionTypes.UPDATE_PROJECT_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        isEditing:false,
        selectedProject: action.payload.project,
        //projects: action.payload.projects,
        successStatus:action.payload.successStatus,
        actionType:action.type,
      };
    }
    case ProjectActionTypes.SEND_PAGES_TO_STUDIO_SUCCESS:
    case ProjectActionTypes.SEND_MANY_PAGES_TO_STUDIO_SUCCESS:
    case ProjectActionTypes.ASSIGN_STUDIOS_TO_JOB_SUCCESS:
    case ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGE_SUCCESS:
    case ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGES_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        successStatus:action.payload.successStatus,
        actionType:action.type,
      };
    }
    case ProjectActionTypes.SEND_PAGES_TO_STUDIO_FAILURE:
    case ProjectActionTypes.SEND_MANY_PAGES_TO_STUDIO_FAILURE:
    case ProjectActionTypes.ASSIGN_STUDIOS_TO_JOB_FAILURE:
    case ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGE_FAILURE:
    case ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGES_FAILURE:
    case ProjectActionTypes.GENERATE_PROJECT_CSV_FAILURE:
    case ProjectActionTypes.VALIDATE_PROJECT_FAILURE: {
      return {
        ...state,
        actionType:action.type,
        errorStatus:action.payload.error,
      };
    }
    case ProjectActionTypes.GET_PERSONS_FAILURE:
    case ProjectActionTypes.GET_PAGE_BACKGROUNDS_FAILURE:
    case ProjectActionTypes.GET_BUSINESS_BRANDS_FAILURE:
    case ProjectActionTypes.GET_STUDIOS_FAILURE:
    case ProjectActionTypes.GET_DOCUMENT_SUB_TYPES_FAILURE:
    case ProjectActionTypes.GET_PAGE_LAYOUTS_FAILURE:
    case ProjectActionTypes.UPDATE_PROJECT_FAILURE:
    case ProjectActionTypes.SET_PROJECT_FAILURE:
    case ProjectActionTypes.GET_PROJECTS_FAILURE: {
      return {
        ...state,
        errorStatus: action.payload.errorStatus,
        actionType:action.type,
        successStatus:null,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/reducers/project.reducer.ts